(() => {
  const root = document.querySelector('[data-sv-product]');
  if (!root) return;

  const read = (sel) => {
    try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { return null; }
  };
  const variants = read('[data-sv-variants]') || [];
  const moneyFormat = read('[data-sv-money]') || '{{amount}}';

  /* Money formatting that mirrors Shopify's money_without_trailing_zeros */
  const money = (cents) => {
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const withCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amount = dec === '00' ? withCommas : `${withCommas}.${dec}`;
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      if (key === 'amount_no_decimals') return withCommas;
      if (key === 'amount_with_comma_separator') return amount.replace(/,/g, '.').replace(/\.(\d{2})$/, ',$1');
      return amount;
    });
  };

  /* Gallery */
  const stage = root.querySelector('[data-sv-stage]');
  const slides = [...root.querySelectorAll('.sv-gallery__slide')];
  const thumbs = [...root.querySelectorAll('.sv-gallery__thumb')];
  const indexEl = root.querySelector('[data-sv-index]');
  const show = (mediaId) => {
    let idx = 0;
    slides.forEach((s, i) => {
      const on = String(s.dataset.mediaId) === String(mediaId);
      s.classList.toggle('is-active', on);
      if (on) idx = i;
    });
    thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.mediaId) === String(mediaId) ? 'true' : 'false'));
    if (indexEl) indexEl.textContent = idx + 1;
    const activeThumb = thumbs[idx];
    if (activeThumb) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  };
  thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.mediaId)));

  // Swipe on touch devices
  if (stage && slides.length > 1) {
    let startX = null;
    stage.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) < 40) return;
      const current = slides.findIndex((s) => s.classList.contains('is-active'));
      const next = (current + (dx < 0 ? 1 : -1) + slides.length) % slides.length;
      show(slides[next].dataset.mediaId);
    });
  }

  // Hover zoom (desktop)
  if (window.matchMedia('(hover: hover)').matches) {
    root.querySelectorAll('[data-sv-zoom]').forEach((z) => {
      const img = z.querySelector('img');
      if (!img) return;
      z.addEventListener('mousemove', (e) => {
        const r = z.getBoundingClientRect();
        img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
        z.classList.add('is-zooming');
      });
      z.addEventListener('mouseleave', () => z.classList.remove('is-zooming'));
    });
  }

  /* Variant selection */
  const form = root.querySelector('#SvProductForm');
  const idInput = root.querySelector('[data-sv-variant-input]');
  const fieldsets = [...root.querySelectorAll('[data-sv-option]')];
  const addBtn = root.querySelector('[data-sv-add]');
  const stickyAdd = root.querySelector('[data-sv-sticky-add]');
  const nowBtn = root.querySelector('.sv-pdp__now-btn');

  const setButton = (btn, available) => {
    if (!btn) return;
    btn.disabled = !available;
    const span = btn.querySelector('span');
    if (span) span.textContent = available ? 'Add to cart' : 'Sold out';
  };

  const update = () => {
    const chosen = fieldsets.map((fs) => fs.querySelector('input:checked')?.value);
    fieldsets.forEach((fs, i) => {
      const label = fs.querySelector('[data-sv-option-label]');
      if (label) label.textContent = chosen[i] || '';
    });
    const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
    if (!v) {
      setButton(addBtn, false);
      setButton(stickyAdd, false);
      return;
    }
    idInput.value = v.id;
    const priceEl = root.querySelector('[data-sv-price]');
    const compareEl = root.querySelector('[data-sv-compare]');
    const saveEl = root.querySelector('[data-sv-save]');
    const stickyPrice = root.querySelector('[data-sv-sticky-price]');
    const badge = root.querySelector('[data-sv-badge]');
    priceEl.textContent = money(v.price);
    if (stickyPrice) stickyPrice.textContent = money(v.price);
    const onSale = v.compare_at_price && v.compare_at_price > v.price;
    compareEl.hidden = !onSale;
    saveEl.hidden = !onSale;
    if (onSale) {
      const pct = Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
      compareEl.textContent = `MRP ${money(v.compare_at_price)}`;
      saveEl.textContent = `Save ${money(v.compare_at_price - v.price)} (${pct}% off)`;
      if (badge) badge.textContent = `${pct}% off`;
    }
    const sku = root.querySelector('[data-sv-sku]');
    if (sku && v.sku) sku.textContent = v.sku;
    setButton(addBtn, v.available);
    setButton(stickyAdd, v.available);
    if (nowBtn) nowBtn.classList.toggle('is-hidden', !v.available);
    if (v.featured_media) show(v.featured_media.id);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  };
  fieldsets.forEach((fs) => fs.addEventListener('change', update));

  /* Quantity stepper */
  root.querySelectorAll('[data-sv-qty]').forEach((b) => {
    b.addEventListener('click', () => {
      const input = b.parentElement.querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.svQty));
    });
  });

  /* Sticky add-to-cart bar once the main button scrolls away */
  const bar = root.querySelector('[data-sv-stickybar]');
  if (bar && addBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (stickyAdd) stickyAdd.tabIndex = visible ? 0 : -1;
    }).observe(addBtn);
  }

  /* Share */
  const share = root.querySelector('[data-sv-share]');
  if (share) {
    share.addEventListener('click', async () => {
      const url = share.dataset.url;
      const label = share.querySelector('span');
      try {
        if (navigator.share) await navigator.share({ title: document.title, url });
        else {
          await navigator.clipboard.writeText(url);
          label.textContent = 'Link copied';
          setTimeout(() => (label.textContent = 'Share'), 2000);
        }
      } catch (e) {}
    });
  }

  if (form && !form.querySelector('[data-sv-variant-input]').value) update();
})();
